/**
 * BehaviourTracker — installs click / scroll-depth / section-dwell tracking on the public
 * marketing pages (see PUBLIC_TRACKED_PATHS). Mount once next to <AnalyticsTracker /> inside
 * <BrowserRouter>. Renders nothing; does nothing when GA4 is off.
 *
 * Mark page regions with `data-section="hero"` etc. to get per-section dwell time. Mark a
 * specific control with `data-track="hero-start-cta"` to give it a stable, rename-proof id.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { installPublicPageTracking, PUBLIC_TRACKED_PATHS } from '@/src/infrastructure/lib/behaviour-analytics';

export function BehaviourTracker(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!PUBLIC_TRACKED_PATHS.includes(pathname)) return undefined;
    return installPublicPageTracking();
  }, [pathname]);

  return null;
}
